module.exports = __webpack_public_path__ + "img/win_11.22f86d49.png";